// Redux Persist 配置
// 配置哪些状态需要持久化存储

import type { PersistConfig } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // localStorage

// 持久化配置
export const persistConfig = {
  key: 'root',
  storage,
  // 指定需要持久化的 reducer
  whitelist: ['user'],
  // 指定不需要持久化的 reducer
  blacklist: [],
  // 版本号，用于数据迁移
  version: 2,
  // 数据迁移配置
  migrate: (state: any) => {
    // v2: 菜单结构变更（如 Web3），丢弃旧 menus 由 AuthGuard 重新注入
    if (state?.user?.menus) {
      return Promise.resolve({
        ...state,
        user: { ...state.user, menus: [] },
      })
    }
    return Promise.resolve(state)
  },
  // 序列化配置
  serialize: true,
  // 反序列化配置
  deserialize: true,
}

// 用户状态持久化配置
export const userPersistConfig: PersistConfig<any> = {
  key: 'user',
  storage,
  // 只持久化用户相关的状态，排除临时状态
  whitelist: ['user', 'token', 'permissions', 'isLoggedIn', 'theme', 'menus'],
  // 排除临时状态
  blacklist: ['loading', 'breadcrumbs'],
  version: 2,
}

// 应用状态持久化配置
export const appPersistConfig: PersistConfig<any> = {
  key: 'app',
  storage,
  whitelist: ['collapsed', 'theme'],
  version: 1,
}

// 缓存配置
export const cacheConfig = {
  // 缓存过期时间（毫秒）
  expireTime: 7 * 24 * 60 * 60 * 1000, // 7天
  // 是否启用缓存
  enabled: true,
  // 缓存键前缀
  keyPrefix: 'vite-admin-',
  // 是否压缩存储
  compress: true,
  // 是否加密存储
  encrypt: false,
}
